<template>
  <div class=''>
    <el-button size="mini" type="primary" @click="add">添加</el-button>
    <el-table
      :data="data"
      style="width: 100%;margin-top:10px">
      <el-table-column
        prop="receiver_name"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.create_time|time}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="del(scope.row.receiver_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align:center">
      <el-pagination
        style="margin-top:10px"
        small
        background
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      receiverList:[],
      data:[],
      page:{
        current:1,
        size:10,
        total:0
      }
    }
  },
  components: {},
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init(){
      this.$axios.get('/receiver',{
        params:{
          current:this.page.current,
          size:this.page.size
        }
      }).then(res=>{
        this.data=res.data.records;
        this.page.total=res.data.total
      });
      this.$axios.get('/receiver').then(res=>{
        this.receiverList=res.data.records
      })
    },
    sizeChange(size){
      this.page.size=size;
      this.init();
    },
    currentChange(current){
      this.page.current=current;
      this.init();
    },
    add(){
      this.$dd.ready(()=> {
        this.$dd.biz.contact.complexPicker({
          title:"选择接收人",            //标题
          corpId:this.$store.state.user.corpId,              //企业的corpId
          multiple:true,            //是否多选
          limitTips:"超出了",          //超过限定人数返回提示
          maxUsers:1,            //最大可选人数
          pickedUsers:[],            //已选用户
          pickedDepartments:[],          //已选部门
          disabledUsers:this.receiverList.map(item=>item.receiver_dd_id),            //不可选用户
          disabledDepartments:[],        //不可选部门
          requiredUsers:[],            //必选用户（不可取消选中状态）
          requiredDepartments:[],        //必选部门（不可取消选中状态）
          appId:22488,              //微应用的Id
          permissionType:"GLOBAL",          //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly:true,        //返回人，或者返回人和部门
          startWithDepartmentId:0 ,   //仅支持0和-1
          onSuccess: res=> {
            const data=res.users.map(item=>{
              return{
                receiver_dd_id:item.emplId
              }
            })[0]
            if(data){
              this.$axios.post('/receiver',data).then(res=>{
                this.$message.success('添加成功！');
                this.page.current=1;
                this.init();
              })
            }
              /**
              {
                  selectedCount:1,                              //选择人数
                  users:[{"name":"","avatar":"","emplId":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                  departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
              }
              */
          },
          onFail : err=> {

          }
        });
      })
    },
    del(id){
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete('/receiver/'+id).then(res=>{
          this.$message.success('删除成功！');
          this.init();
        })
      }).catch(() => {

      });
    }
  }
}
</script>
<style scoped>

</style>